"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastCompletePeriod = void 0;
var date_fns_1 = require("date-fns");
var getLastCompletePeriod = function (periods) {
    return periods.reduce(function (acc, period) {
        if ((0, date_fns_1.isPast)(period.end) && (!acc || (0, date_fns_1.isAfter)(period.end, acc.end))) {
            return period;
        }
        return acc;
    }, undefined);
};
exports.getLastCompletePeriod = getLastCompletePeriod;
